import React, {useState, useEffect, useRef} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';

export function DhcdSubmenu({tabs = [], active, onChange}) {
    const [isDesktop, setIsDesktop] = useState(false);

    // ===== detect desktop =====
    useEffect(() => {
        const media = window.matchMedia('(min-width: 1024px)');
        const update = () => setIsDesktop(media.matches);
        update();
        media.addEventListener('change', update);
        return () => media.removeEventListener('change', update);
    }, []);

    // ===== mobile drag logic (giữ nguyên) =====
    const listRef = useRef(null);
    const isDown = useRef(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);

    const onMouseDown = e => {
        isDown.current = true;
        listRef.current.classList.add('dragging');
        startX.current = e.pageX - listRef.current.offsetLeft;
        scrollLeft.current = listRef.current.scrollLeft;
    };

    const onMouseLeave = () => {
        isDown.current = false;
        listRef.current.classList.remove('dragging');
    };

    const onMouseUp = () => {
        isDown.current = false;
        listRef.current.classList.remove('dragging');
    };

    const onMouseMove = e => {
        if (!isDown.current) return;
        e.preventDefault();
        const x = e.pageX - listRef.current.offsetLeft;
        const walk = (x - startX.current) * 1.2;
        listRef.current.scrollLeft = scrollLeft.current - walk;
    };

    // ===== DESKTOP: Swiper =====
    if (isDesktop) {
        return (
            <nav className="dhcd-submenu">
                <Swiper
                    slidesPerView="auto"
                    freeMode
                    className="dhcd-submenu-swiper"
                    breakpoints={{
                        0: {spaceBetween: 10},
                        1024: {spaceBetween: 24},
                    }}>
                    {tabs.map(tab => (
                        <SwiperSlide
                            key={tab.key}
                            tag="li"
                            style={{width: 'auto'}}
                            className={Number(tab.key) === Number(active) ? 'active' : ''}
                            onClick={() => onChange(Number(tab.key))}>
                            {tab.label}
                        </SwiperSlide>
                    ))}
                </Swiper>
            </nav>
        );
    }

    // ===== MOBILE: giữ nguyên code cũ =====
    return (
        <nav className="dhcd-submenu">
            <ul
                ref={listRef}
                onMouseDown={onMouseDown}
                onMouseLeave={onMouseLeave}
                onMouseUp={onMouseUp}
                onMouseMove={onMouseMove}>
                {tabs.map(tab => (
                    <li
                        key={tab.key}
                        className={Number(tab.key) === Number(active) ? 'active' : ''}
                        onClick={() => onChange(Number(tab.key))}>
                        {tab.label}
                    </li>
                ))}
            </ul>
        </nav>
    );
}
